<template>
  <div class="wrapper" :key="customKey">
    <div class="card">
      <div class="text-username">
        <div class="text" v-html="comment.comment.text"></div>
      </div>
      <div class="comment-date">
        {{ formatCommentDate(comment.comment.createdAt) }}
        <v-btn
          v-if="hasAdminPermissions"
          icon
          color="red"
          @click="deleteComment(comment.comment.id, false)"
        >
          <font-awesome-icon icon="times" />
        </v-btn>
      </div>

      <div v-if="loggedIn">
        <v-dialog v-model="dialog" width="1000">
          <template v-slot:activator="{ on, attrs }">
            <div class="answer" v-bind="attrs" v-on="on">
              <svg
                @click="addReply = true"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 14L4 9L9 4"
                  stroke="#6D6963"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20 20V13C20 11.9391 19.5786 10.9217 18.8284 10.1716C18.0783 9.42143 17.0609 9 16 9H4"
                  stroke="#6D6963"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </template>

          <v-card style="background-color: #d9d9d9" class="px-3 py-3 modal">
            <div v-if="addReply" class="add-subcomment">
              <quill-editor
                v-model="subcontent"
                ref="myQuillEditor"
                :options="editorOption"
                class="window-edit"
              />
              <div
                @click="addSubComment"
                class="send-message-icon"
                style="cursor: pointer; padding-bottom: 10px"
              >
                <svg
                  width="36"
                  height="34"
                  viewBox="0 0 36 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="17.6296"
                    cy="17"
                    rx="17.6296"
                    ry="17"
                    fill="#D9D9D9"
                  />
                  <path
                    d="M18 25V9"
                    stroke="#8B857D"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 17L18 9L26 17"
                    stroke="#8B857D"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </div>

      <div
        class="comment-images"
        v-if="
          comment && comment.comment.images && comment.comment.images.length > 0
        "
      >
        <v-dialog
          width="650"
          v-for="image in comment.comment.images"
          :key="image.id"
          v-model="dialog3"
        >
          <template v-slot:activator="{ on, attrs }">
            <img
              @click="assignTemporarysrc(fetchCommentImage(image.id))"
              v-bind="attrs"
              v-on="on"
              :src="fetchCommentImage(image.id)"
              alt=""
              class="mini-image"
              loading="lazy"
            />
          </template>

          <v-card class="px-3 py-3">
            <img
              class="modal-img"
              :src="temporarySrc"
              alt=" kręgosłup
            "
              loading="lazy"
            />
          </v-card>
        </v-dialog>
      </div>
    </div>

    <div class="" style="display: flex; gap: 20px; margin-top: 10px">
      <div class="image-modal">
        <v-dialog v-model="dialog1" width="650">
          <template v-slot:activator="{ on, attrs }">
            <img
              style="
                width: 30px;
                min-width: 30px;
                max-width: 30px;
                min-height: 30px;
                max-height: 30px;
                object-fit: cover;
                border-radius: 999px;
              "
              v-bind="attrs"
              v-on="on"
              :src="imageSrc"
              alt="
              "
              loading="lazy"
            />
          </template>

          <v-card class="px-3 py-3">
            <img
              class="modal-img"
              :src="imageSrc"
              alt="
             "
              loading="lazy"
            />
          </v-card>
        </v-dialog>
      </div>
      <div class="username">{{ comment.user.login }}</div>
    </div>

    <div class="" v-for="subcomment in subComments" :key="subcomment.id">
      <div class="subcomment-card">
        <div class="text-username">
          <div class="text" v-html="subcomment.subComment.text"></div>
        </div>
        <div class="comment-date">
          {{ formatCommentDate(subcomment.subComment.createdAt) }}

          <v-btn
            v-if="hasAdminPermissions"
            icon
            color="red"
            @click="deleteComment(subcomment.subComment.id, true)"
          >
            <font-awesome-icon icon="times" />
          </v-btn>
        </div>
      </div>
      <div class="under-subcomment-card-text">
        <div class="image-modal">
          <v-dialog v-model="dialog2" width="650">
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                style="
                  width: 30px;
                  min-width: 30px;
                  max-width: 30px;
                  min-height: 30px;
                  max-height: 30px;
                  object-fit: cover;
                  border-radius: 999px;
                "
                :src="fetchSubProfilePic(subcomment.user.id)"
                alt="
              "
                loading="lazy"
              />
            </template>

            <v-card class="px-3 py-3">
              <img
                style="
                  width: 30px;
                  min-width: 30px;
                  max-width: 30px;
                  min-height: 30px;
                  max-height: 30px;
                  object-fit: cover;
                  border-radius: 999px;
                "
                class="modal-img"
                :src="fetchSubProfilePic(subcomment.user.id)"
                alt="
              Nauli,
              subskrypcja DagaJoga
              filmy jogi,
              szkoła online,
              joga,
              kurs jogi online,
              uważna praktyka,
              joga wzmacniająca,
              joga online,
              praktyka wzmacniająca,
              praktyka,
              ćwiczenia online
              "
                loading="lazy"
              />
            </v-card>
          </v-dialog>
        </div>
        <div class="username">{{ subcomment.user.login }}</div>
      </div>
    </div>
    <before-delete-modal
      :isVisible="isDeleteModalVisible"
      @closeModal="closeDeleteModal()"
      @confirmDeletion="confirmDeleteComment()"
    />
  </div>
</template>

<script>
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { API_URL } from "../axios";
import moment from "moment";
import BeforeDeleteModal from "./modals/BeforeDeleteModal.vue";
export default {
  name: "Comment",
  props: {
    comment: Object,
    timePackageId: String,
    customKey: String,
    hasAdminPermissions: Boolean,
  },
  data: () => ({
    loggedIn: false,
    addReply: false,
    dialog1: null,
    dialog: null,
    dialog2: null,
    dialog3: null,
    isFetching: true,
    image_url: "",
    pic: "",
    imageSrc: "",
    subImageSrc: "",
    commentPics: "",
    subcontent: "",
    temporarySrc: "",
    editorOption: {
      debug: "error",
      placeholder: "Dodaj komentarz...",
      readOnly: true,
      theme: "snow",
      formats: [
        "bold",
        "color",
        "background",
        "size",
        "italic",
        "underline",
        "emoji",
        "strike",
        "align",
      ],
      modules: {
        toolbar: {
          container: [
            [{ size: ["small", false, "large"] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            ["emoji"],
          ],
          handlers: {
            emoji: function () {},
          },
        },
        toolbar_emoji: true,
      },
    },
    delta: undefined,
    showImageModal: false,
    formEntered: false,
    subComments: [],
    selectedForDelete: null,
    isDeleteModalVisible: false,
  }),
  components: {
    quillEditor,
    BeforeDeleteModal,
  },

  watch: {
    async customKey() {
      this.pic = await this.$store.dispatch(
        `auth/fetchCommentPicture`,
        this.comment.user.id
      );
      this.imageSrc = this.pic;
      await this.getSubComments();
    },
  },

  async created() {
    const token = window.localStorage.getItem("userToken");
    if (token) {
      this.loggedIn = true;
    }
    this.pic = await this.$store.dispatch(
      `auth/fetchCommentPicture`,
      this.comment.user.id
    );
    this.commentPics = this.comment.images;
    this.imageSrc = this.pic;
    this.getSubComments();
  },

  methods: {
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
    },
    async confirmDeleteComment() {
      const { id, isSubComment } = this.selectedForDelete;
      if (isSubComment) {
        await this.$store.dispatch("comments/deleteSubComment", {
          subCommentId: id,
        });
      } else {
        await this.$store.dispatch("comments/deleteComment", {
          id: id,
        });
      }
      this.$emit("deleted");
    },
    async deleteComment(id, isSubComment) {
      this.isDeleteModalVisible = true;
      this.selectedForDelete = { id, isSubComment };
    },
    fetchSubProfilePic(id) {
      return `${API_URL}/profile/${id}/image`;
    },
    formatCommentDate(date) {
      const formattedDate = moment(date).format("YYYY-DD-MM HH:mm");
      return formattedDate;
    },
    fetchCommentImage(id) {
      return `${API_URL}/comments/images/${id}`;
    },
    async addSubComment() {
      const response = await this.$store.dispatch("comments/addSubComment", {
        id: this.comment.comment.id,
        text: this.subcontent,
      });
      if (response) {
        this.getSubComments();
        this.dialog = false;
        this.subcontent = "";
        this.$emit("subCommentAdded");
      }
    },
    async getSubComments() {
      const response = await this.$store.dispatch(
        "comments/fetchSubcommentsForComments",
        {
          id: this.comment.comment.id,
        }
      );
      this.subComments = response;
    },
    assignTemporarysrc(src) {
      this.temporarySrc = src;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Poppins:wght@300;400;600;700&family=Raleway:wght@400;500&family=Roboto:wght@300;400;500;700&display=swap");
* {
  font-family: "Inter", sans-serif;
}

.wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.comment-images {
  display: flex;
  gap: 0.1rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  .mini-image {
    width: 75px;
    height: 75px;
    object-fit: cover;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    cursor: pointer;
  }
}
.button-s {
  margin: 0;
  margin-top: 50px;
}

.username {
  color: #6d6963;
  font-weight: 600;
  font-size: 20px;
}

.subcomment-card {
  .text-username {
    width: 100%;
    margin-left: 20px;
    .username {
      max-width: 100%;
      margin-left: 0px;
    }
  }
}
.comment-date {
  position: absolute;
  font-size: 12px;
  bottom: 0.5rem;
  left: 1rem;
  color: #8b857d;
}
.card,
.subcomment-card {
  width: 1000px;
  height: fit-content;
  overflow: hidden;
  min-height: 100px;
  transition: all 0.5s ease;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  border-radius: 20px;

  img {
    height: 100px;
    width: 100px;
    object-fit: cover;
    margin: 20px;
    border-radius: 100px;
  }
  .text {
    max-width: 80%;
    display: block;
    height: fit-content;
    text-align: left;
    margin: 20px;
    margin-right: 0;
    word-wrap: break-word;
    object-fit: cover;
    color: #54514c;
    font-size: 14px;
  }
  h5 {
    font-size: 1.2rem;
    margin: 0 7px;
  }
  i {
    font-size: 1.3rem;
    padding-top: 5px;
    transition: all 0.3s;
  }
  .answer {
    cursor: pointer;
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    &:hover {
      i {
        color: #d1acac;
      }
    }
  }
}
.card {
  border-bottom-left-radius: 0;
  padding-bottom: 40px;
  margin-top: 50px;
  max-width: 80%;
  margin-right: auto;
}
.window-edit {
  width: 100%;
}
.button-s {
  width: 100%;
  margin-top: 20px;
}

.subcomment-card {
  border-bottom-right-radius: 0;
  max-width: 80%;
  margin-left: auto;
}
.under-subcomment-card-text {
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  margin-top: 10px;
}
.add-subcomment {
  width: 100%;
  margin-bottom: 50px;
}
.modal {
  overflow: hidden;
}

::v-deep img {
  max-width: 100%;
}

.modal-img {
  width: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1050px) {
  .card {
    padding: 1rem;
  }
  .subcomment-card {
    width: 70vw;
    margin-top: 20px;
  }
}

@media screen and (max-width: 630px) {
  .button-s {
    margin-top: 80px;
  }
  .card {
    width: 100%;
    max-width: 100%;
  }
  .subcomment-card {
    width: 90%;
    max-width: 90%;
  }
}
</style>
